var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReservedTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 135,
    viewBox: "0 0 146 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.701 47.9301V33.6743C139.701 27.5005 133.639 22.4492 126.231 22.4492H18.4701C11.0615 22.4492 5.06735 27.4444 5.06735 33.6743V47.9301C5.06735 51.8027 7.28991 55.6192 11.3983 57.4152C15.6413 59.3796 18.4701 63.0839 18.4701 67.3494C18.4701 71.6149 15.574 75.3753 11.3309 77.2275C7.28991 79.0796 5 82.8961 5 86.7687V101.025C5 107.198 11.0615 112.25 18.4701 112.25H126.231C133.639 112.25 139.701 107.198 139.701 101.025V86.7687C139.701 82.8961 137.411 79.0796 133.37 77.2275C129.127 75.3192 126.231 71.6149 126.231 67.3494C126.231 63.0839 129.127 59.3796 133.37 57.4714C137.411 55.6192 139.701 51.8027 139.701 47.9301V47.9301Z",
    fill: "#00A9F2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 29.9336,
    width: 4.15742,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114.758,
    y: 29.9336,
    width: 4.15742,
    height: 4.15743,
    fill: "#D9F7F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 41.5742,
    width: 4.15742,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.758,
    y: 41.5742,
    width: 4.15739,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 53.2148,
    width: 4.15742,
    height: 4.15741,
    fill: "#D9F7F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.754,
    y: 53.2148,
    width: 4.15741,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 64.8555,
    width: 4.15743,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114.758,
    y: 64.8555,
    width: 4.1574,
    height: 4.15741,
    fill: "#D9F7F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 76.4961,
    width: 4.15742,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 114.758,
    y: 76.4961,
    width: 4.15742,
    height: 4.15743,
    fill: "#D9F7F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 88.1367,
    width: 4.15742,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 114.758,
    y: 88.1367,
    width: 4.15742,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2812,
    y: 99.7773,
    width: 4.15743,
    height: 4.15742,
    fill: "#D9F7F2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 114.754,
    y: 99.7773,
    width: 4.15744,
    height: 4.15741,
    fill: "#D9F7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3828 67.9275C49.3828 54.9308 59.9308 44.3828 72.9275 44.3828C85.9241 44.3828 96.4721 54.9308 96.4721 67.9275C96.4721 80.9241 85.9241 91.4721 72.9275 91.4721C59.9308 91.4721 49.3828 80.9241 49.3828 67.9275ZM59.8797 69.377L67.3148 76.8121C68.1226 77.6198 69.448 77.6198 70.235 76.8121L85.9543 61.0928C86.7621 60.2851 86.7621 58.9803 85.9543 58.1726C85.1466 57.3649 83.8419 57.3649 83.0342 58.1726L68.7853 72.4215L62.7999 66.4568C61.9922 65.6491 60.6875 65.6491 59.8797 66.4568C59.4919 66.8438 59.274 67.3691 59.274 67.9169C59.274 68.4647 59.4919 68.9901 59.8797 69.377Z",
    fill: "#E6F6FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 18.1992,
    width: 145.701,
    height: 102.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedTickets);
export default __webpack_public_path__ + "static/media/reserved-tickets.ee11cb8e5a278822f3b4954790b72bf5.svg";
export { ForwardRef as ReactComponent };